/*
 * @Description: 工具集合
 * @Date: 2019-09-17 10:55:01
 */
import { Message, MessageBox } from 'element-ui';
import axios from 'axios';

/**
 * @description: 简易拷贝
 * @param {object} target
 * @return: object
 */
export const easyCopy = target => {
  return JSON.parse(JSON.stringify(target));
};
/**
 * @description: 深拷贝
 * @param {object} target
 * @return: object
 */
export const deepClone = target => {
  let result;
  if (typeof target === 'object') {
    if (Array.isArray(target)) {
      result = [];
      for (let i in target) {
        result.push(deepClone(target[i]));
      }
    } else if (target === null) {
      result = null;
    } else if (target.constructor === RegExp) {
      result = target;
    } else {
      result = {};
      for (let i in target) {
        result[i] = deepClone(target[i]);
      }
    }
  } else {
    result = target;
  }
  return result;
};
/**
 * @description: 获取类型
 * @param {type} field 传入需要判断的字段
 * @return: {string}  [object Number] [object String] [object Number]
 *                    [object Function] [object Array] [object Undefined]
 *                    [object Boolean] [object Null]
 */
export const getTypeToString = field => {
  return Object.prototype.toString.call(field);
};

/**
 * @description: 获取百分比
 * @param {number,number,object}
 * @return: string|number
 */
export const percentage = (dividend = 0, divisor = 100, options = {}) => {
  let args = { digit: 2, multiple: 100, symbol: '%', ...options };
  let res = ((dividend / divisor) * args.multiple).toFixed(args.digit);
  let p = isNaN(res) ? 0 : res;
  return p;
};
/**
 * @description: 确认操作，需要兼容之前mixin
 * @param Function 回调
 * @param Object 当前数据
 * @param String 提示
 * @return: void
 */
export const makeSure = (cb = null, row = null, text = '是否确定操作？') => {
  MessageBox.confirm(text, {
    // FIX: 添加loading
    async beforeClose(action, instance, done) {
      if (action === 'confirm') {
        instance.confirmButtonLoading = true;
        instance.confirmButtonText = '执行中...';
        try {
          await cb(row);
          done();
        } catch (e) {
          console.error(e);
        }
        instance.confirmButtonText = '确定';
        instance.confirmButtonLoading = false;
      } else {
        done();
      }
    }
  })
    .then(() => {})
    .catch(() => {
      Message('取消操作');
    });
};
// base64转换为blob流
export const dataURLToBlob = dataurl => {
  let arr = dataurl.split(',');
  let mime = arr[0].match(/:(.*?);/)[1];
  let bstr = atob(arr[1]);
  let n = bstr.length;
  let u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
};
// blob流转换为base64
export const blobToDataURI = blob => {
  return new Promise(resolve => {
    let reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onload = e => {
      resolve(e.target.result);
    };
  });
};
export const getNetFile = async (
  url,
  responseType = 'blob',
  options = { data: { noInterceptor: true } }
) => {
  let { data } = await axios.get(url, {
    responseType,
    ...options
  });
  return data;
};
export const image2Base64 = img => {
  let canvas = document.createElement('canvas');
  let ctx = canvas.getContext('2d');
  canvas.width = img.width;
  canvas.height = img.height;
  ctx.drawImage(img, 0, 0, img.width, img.height);
  let dataURL = canvas.toDataURL('image/png');
  return dataURL;
};
export const getImgBase64 = src => {
  return new Promise(resolve => {
    let base64 = '';
    let img = new Image();
    img.setAttribute('crossOrigin', 'anonymous');
    img.src = src;
    img.onload = () => {
      base64 = image2Base64(img);
      resolve(base64);
    };
  });
};

export const uniqueByFieldName = (array, id) => {
  if (!Array.isArray(array)) {
    return new TypeError('array:' + array);
  }
  let result = [];
  let keys = {};
  for (var i = 0; i < array.length; i++) {
    let row = array[i];
    if (!keys[row[id]]) {
      keys[row[id]] = result.push(row);
    }
  }
  return result;
};
/**
 * @description: *代替字符串部分内容
 * @param {content} 内容
 * @param {start} 开始部分
 * @param {end} 结束部分
 * @return: String
 */
export const hideSomeString = (content, start = 3, end = 7, stars = 4) => {
  // return content.replace(/(\d{3})(\d{4})(\d{4})/, '$1****$3');
  content = String(content);
  return content.substr(0, start) + '*'.repeat(stars) + content.substr(end);
};

/**
 * @name 根据枚举生成 select 选项
 * @param enums
 * @param fieldLable
 * @param fieldKey
 * @return {[{label: string, value: string}]}
 */
export const makeSelectOptionsByEnum = (
  enums,
  fieldLable = 'label',
  fieldKey = 'value'
) => {
  let arr = [];
  for (let key in enums) {
    let label = enums[key];
    arr.push({
      [fieldLable]: label + '',
      [fieldKey]: key + ''
    });
  }
  arr.sort((a, b) => Math.abs(a.value) - Math.abs(b.value));
  // return res.sort((a, b) => a.order - b.order);
  return [
    {
      [fieldLable]: '全部',
      [fieldKey]: ''
    },
    ...arr
  ];
};

// 处理日期字段 有可能是字符串 ，也有可能是时间戳的情况
export const fieldRender = (type, val) => {
  // 时间戳 正则
  const tempReg = /\d{13}/g;
  const timeStr = /^\d+-\d+-\d+/g;

  if (type === 'datetime') {
    if (tempReg.test(val)) {
      let date = new Date(val);
      let yyyy = date.getFullYear(),
        MM = (date.getMonth() + 101 + '').slice(1),
        dd = (date.getDate() + 100 + '').slice(1),
        HH = (date.getHours() + 100 + '').slice(1),
        mm = (date.getMinutes() + 100 + '').slice(1),
        ss = (date.getSeconds() + 100 + '').slice(1);
      return `${yyyy}-${MM}-${dd} ${HH}:${mm}:${ss}`;
    }
    if (timeStr.test(val)) {
      return val;
    }
  }
};

/**
 * 下载文件
 * @param {*} fileName
 * @param {*} content
 */
export const downloadFile = async (fileName, url, options = {}) => {
  try {
    let res = await axios({
      method: 'get',
      url,
      responseType: 'arraybuffer',
      headers: {
        // [Config.token]: getToken()
      },
      ...options
    });
    if (res.status === 201) {
      let message = new Blob([res.data]);
      var reader = new FileReader();
      reader.readAsText(message, 'utf-8');
      reader.onload = function(e) {
        Message.error(reader.result);
      };
      return;
    }
    if (res.status !== 200) {
      Message.error('下载失败，请联系管理员');
      return;
    }
    const blob = new Blob([res.data]);
    if (window.navigator.msSaveOrOpenBlob) {
      navigator.msSaveBlob(blob, fileName);
    } else {
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(link.href);
    }
    return Promise.resolve();
  } catch (e) {
    return Promise.reject(e);
  }
};

export const makeTableRenderOptionsByMap = (map, all) => {
  if (
    !Object.prototype.toString
      .call(map)
      .toLowerCase()
      .includes('map')
  ) {
    throw new TypeError('map 参数类型错误');
  }
  let res = [];
  all && res.push({ name: '全部', key: '' });
  try {
    map.forEach((v, k) => {
      res.push({
        name: v,
        key: k
      });
    });
  } catch (err) {
    return res;
  }
  return res;
};
export const flat = arr => {
  return arr.reduce((pre, cur) => {
    return pre.concat(Array.isArray(cur) ? flat(cur) : cur);
  }, []);
};

/**
 * @param obj 冻结对象 property 的定义和删除，delete obj 和 Object.assign(obj) 会报错，
 * @returns {*}
 */
export const freezePropertyAlter = obj => {
  Object.freeze(obj);
  Object.preventExtensions(obj);
  return obj;
};
// 节流（时间戳+定时器）：
export const throttle = function(func, delay) {
  var timer = null;
  var startTime = Date.now();
  return function() {
    var curTime = Date.now();
    var remaining = delay - (curTime - startTime);
    var context = this;
    var args = arguments;
    clearTimeout(timer);
    if (remaining <= 0) {
      func.apply(context, args);
      startTime = Date.now();
    } else {
      timer = setTimeout(func, remaining);
    }
  };
};

/**
 * @desc  函数防抖---“立即执行版本” 和 “非立即执行版本” 的组合版本
 * @param  func 需要执行的函数
 * @param  wait 延迟执行时间（毫秒）
 * @param  immediate---true 表立即执行，false 表非立即执行
 **/
export const debounce = (func, wait = 200, immediate = false) => {
  let timer;
  return function() {
    let context = this;
    let args = arguments;

    if (timer) clearTimeout(timer);
    if (immediate) {
      var callNow = !timer;
      timer = setTimeout(() => {
        timer = null;
      }, wait);
      if (callNow) func.apply(context, args);
    } else {
      timer = setTimeout(function() {
        func.apply(context, args);
      }, wait);
    }
  };
};
/**
 * 复制文本
 * @param {String} value 需要复制的文本
 */
export const copyText = value => {
  if (!value) return console.log('无复制内容');
  // 判断当前环境是否支持navigator.clipboard 对象
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard
      .writeText(value)
      .then(() => {
        Message.success('复制成功');
      })
      .catch(() => {
        Message.error('复制失败');
      });
  } else {
    // 动态创建 textarea 标签
    const textarea = document.createElement('textarea');
    // 将该 textarea 设为 readonly 防止 iOS 下自动唤起键盘
    textarea.setAttribute('readonly', true);
    // 将要 copy 的值赋给 textarea 标签的 value 属性
    textarea.setAttribute('value', value);
    // 将 textarea 插入到 body 中
    document.body.appendChild(textarea);
    // 选中值并复制
    textarea.select();
    textarea.setSelectionRange(0, textarea.value.length);
    const result = document.execCommand('copy');
    if (result) {
      Message.success('复制成功');
    } else {
      Message.error('复制失败');
    }
    // 操作完成后删除标签
    document.body.removeChild(textarea);
  }
};
